import { render } from "./Standard.vue?vue&type=template&id=d9304b8e"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__